import { TopMoneySpenderTable } from './TopMoneySpenderTable'
import { withTopMoneySpenderTable } from './withTopMoneySpenderTable'

const Connected = withTopMoneySpenderTable(TopMoneySpenderTable)

export { Connected as TopMoneySpenderTable }
